import { ModalButton as ModalButtonType } from '@/schemas/sceneDataSchema';
import useModal from '@/hooks/use-modals';
import { ComponentButton } from './ComponentButton';

export const ModalButton = ({ component }: { component: ModalButtonType }) => {
  const { getModal } = useModal();
  const modal = getModal(component.modal_id);
  const onClick = () => {
    if (modal === undefined) {
      return;
    }
    if (component.method_type === 'open') {
      modal?.open();
    } else if (component.method_type === 'close') {
      modal.close();
    } else if (component.method_type === 'toggle') {
      modal.toggle();
    }
  };

  return (
    <ComponentButton
      onClick={onClick}
      component={component}
      type='button'
    />
  );
};
